module.exports = __webpack_public_path__ + "img/cost-icon__lobby_lounge.43a8d424.svg";